import * as React from 'react';
import { AboutTabItem, ENV } from '~/common/enums/enums';
import {
  footerPayload,
  headerPayload,
  navigationPayload,
} from '~/common/payload/payload';
import { AboutLayout } from '~/components/common/common';
import { BSDescription } from '~/components/sections/sections';
import { bsDescriptionPayload, seoPayload } from './data/data';

const Page: React.FC = () => (
  <AboutLayout
    seoPayload={seoPayload}
    headerPayload={headerPayload}
    footerPayload={footerPayload}
    navigationPayload={navigationPayload}
    activeTabItem={AboutTabItem.BS}
    registrationLink={ENV.APP.REGISTRATION_LINK}
  >
    <h1 className="visually-hidden">Binary Studio</h1>
    <BSDescription payload={bsDescriptionPayload} />
  </AboutLayout>
);

export { Page };
